import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx } from "react/jsx-runtime";
import { useNavigate } from 'react-router-dom';
import { routes } from '~/constants';
import { useOverlayContext, useStoreActions } from '~/contexts';
import { useDuplicateProposal } from '~/hooks/reactQuery/mutations/useDuplicateProposal';
import { useDownloadAgreementPdf } from '~/hooks/relationship/useDownloadAgreementPdf';
import { useRedirectToProposal } from '~/hooks/useCreateAgreement';
import { useEnterAccountantAccess } from '~/hooks/useEnterAccountantAccess';
import { useTerminateAgreement } from '~/hooks/useTerminateAgreement';
import { useLocaleKeys } from '~/i18n';
import { handleRequest } from '~/infra/utils';
import ChangeAssigneeModal from './ChangeAssigneeModal';
import RenameAgreementModal from './RenameAgreementModal';
const relationshipLoader = 'getRelationship';
export function useAgreementRowActions(param) {
    let { onTerminateSuccess, onUpdateSuccess } = param;
    const overlayContext = useOverlayContext();
    const { api } = useStoreActions();
    const { t: errorTexts } = useLocaleKeys('errors');
    const navigate = useNavigate();
    const { downloadAgreementPdf } = useDownloadAgreementPdf();
    const { redirectToProposal } = useRedirectToProposal();
    const { duplicateProposal } = useDuplicateProposal({
        onSuccess: (newDraftId)=>redirectToProposal({
                proposalType: 'agreement',
                draftId: newDraftId
            }),
        withPageLoader: true
    });
    const { terminateAgreementById } = useTerminateAgreement();
    const enterAccountantAccess = useEnterAccountantAccess();
    const onDownloadPDF = (agreement)=>{
        downloadAgreementPdf(agreement.id);
    };
    const onTerminateAgreement = (agreement)=>{
        terminateAgreementById({
            id: agreement.id,
            postAction: ()=>{
                onTerminateSuccess();
            }
        });
    };
    const onEditAgreement = (agreement)=>{
        navigate(routes.editAgreement(agreement.id));
    };
    const onDuplicateAgreement = (agreement)=>{
        duplicateProposal({
            relationshipId: agreement.id,
            draftId: agreement.draftId
        });
    };
    async function onRenameAgreement(agreement, onSuccess) {
        overlayContext.startLoader(relationshipLoader);
        const relationship = await handleRequest(api.relationship.get(agreement.id));
        overlayContext.stopLoader(relationshipLoader);
        if (!relationship.success) {
            overlayContext.showErrorToast(errorTexts.unexpected(), 'get-agr-error');
        } else {
            overlayContext.showModal({
                biName: 'rename_agreement_modal',
                closeOnClickOutside: true,
                closeOnEscapeKey: true,
                content: (p)=>/*#__PURE__*/ _jsx(RenameAgreementModal, _object_spread_props(_object_spread({}, p), {
                        relationship: relationship.data,
                        onSuccess: onSuccess
                    }))
            });
        }
    }
    function onChangeAssignee(agreement) {
        overlayContext.showModal({
            biName: 'change_assignee_modal',
            closeOnClickOutside: true,
            closeOnEscapeKey: true,
            content: (p)=>/*#__PURE__*/ _jsx(ChangeAssigneeModal, _object_spread({
                    id: agreement.id,
                    onSuccess: async ()=>onUpdateSuccess()
                }, p))
        });
    }
    return {
        onEditAgreement,
        onRenameAgreement,
        onChangeAssignee,
        onDuplicateAgreement,
        onTerminateAgreement,
        onDownloadPDF,
        onEnterAccountantAccess: enterAccountantAccess
    };
}
